// Generated by ts-to-zod
import { z } from "zod";
const allowedValuesMediaSchema = z.object({
    media: z
        .object({
        id: z.string(),
        url: z.string(),
        title: z.string(),
        mimeType: z.string(),
    })
        .nullable(),
});
const allowedValuesMediaStrictSchema = z.object({
    media: z
        .object({
        id: z.string(),
        url: z.string(),
        title: z.string(),
        mimeType: z.string(),
    })
});
export const props2AllowedValuesNumberSchema = z
    .object({
    allowedNumber: z.number(),
})
    .and(allowedValuesMediaSchema);
export const props2AllowedValuesTextSchema = z
    .object({
    allowedText: z.string(),
})
    .and(allowedValuesMediaSchema);
export const props2ValuesMediaBoolSchema = z
    .object({
    bool: z.boolean(),
})
    .and(allowedValuesMediaStrictSchema);
export const props2NumberRangeSchema = z.object({
    min: z.number().nullable(),
    max: z.number().nullable(),
});
export const props2NumberUnitSchema = z.string();
const askWhenSchema = z.enum([
    "onQuoteCreate",
    "onQuoteRefinement",
    "onQuoteRefinement2",
    "onQuoteRefinement3",
    "onEmbeddableWizard",
    "onCallAssistant"
]);
const askWhomSchema = z.enum(["contractee", "contractor"]);
const questionControlSchema = z.object({
    askWhen: askWhenSchema.array(),
    askWhom: askWhomSchema.array()
}).array();
export const props2AskWhenSchema = askWhenSchema;
export const props2AskWhomSchema = askWhomSchema;
export const props2NumberSchema = z.object({
    kind: z.literal("Props2Number"),
    key: z.string(),
    label: z.string(),
    valueNumber: z.number().nullable(),
    allowedValuesNumber: z.array(props2AllowedValuesNumberSchema),
    range: props2NumberRangeSchema.nullable(),
    unit: props2NumberUnitSchema.nullable(),
    step: z.number().nullable().default(null),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2TextSchema = z.object({
    kind: z.literal("Props2Text"),
    key: z.string(),
    label: z.string(),
    valueText: z.string().nullable(),
    allowedValuesText: z.array(props2AllowedValuesTextSchema),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2NumberArraySchema = z.object({
    kind: z.literal("Props2NumberArray"),
    key: z.string(),
    label: z.string(),
    valueNumberArray: z.array(z.number()).nullable(),
    allowedValuesNumber: z.array(props2AllowedValuesNumberSchema),
    range: props2NumberRangeSchema.nullable(),
    unit: props2NumberUnitSchema.nullable(),
    step: z.number().nullable().default(null),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2TextArraySchema = z.object({
    kind: z.literal("Props2TextArray"),
    key: z.string(),
    label: z.string(),
    valueTextArray: z.array(z.string()).nullable(),
    allowedValuesText: z.array(props2AllowedValuesTextSchema),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2BoolSchema = z.object({
    kind: z.literal("Props2Bool"),
    key: z.string(),
    label: z.string(),
    valueBool: z.boolean().nullable(),
    valuesMediaBool: z.array(props2ValuesMediaBoolSchema),
    essential: z.boolean(),
    group: z.string(),
    clientVisibility: z.boolean(),
    prompt: z.string(),
    questionControl: questionControlSchema,
    customizable: z.boolean()
});
export const props2Schema = z.union([
    props2NumberSchema,
    props2TextSchema,
    props2BoolSchema,
    props2NumberArraySchema,
    props2TextArraySchema,
]);
/**
 * The API-boundary consolidated shape: a property plus the expression data the
 * document logic layer holds. The ten legacy kinds survive here and only here —
 * `projectPropToLegacyConsolidated` in `@msys/document-core` reconstructs them,
 * and the PDF-generation payload carries them.
 */
const props2ComputedConsolidatedBaseSchema = z.object({
    key: z.string(),
    label: z.string(),
    group: z.string(),
    clientVisibility: z.boolean(),
    expr: z.string(),
    missingValue: z.boolean(),
    aliasedExpr: z.string(),
});
export const props2ConsolidatedSchema = z.union([
    props2NumberSchema,
    props2TextSchema,
    props2BoolSchema,
    props2NumberArraySchema,
    props2TextArraySchema,
    props2ComputedConsolidatedBaseSchema.extend({
        kind: z.literal("Props2BoolComputed"),
        valueBoolComputed: z.boolean().nullable(),
    }),
    props2ComputedConsolidatedBaseSchema.extend({
        kind: z.literal("Props2NumberComputed"),
        unit: props2NumberUnitSchema.nullable(),
        valueNumberComputed: z.number().nullable(),
    }),
    props2ComputedConsolidatedBaseSchema.extend({
        kind: z.literal("Props2TextComputed"),
        valueTextComputed: z.string().nullable(),
    }),
    props2ComputedConsolidatedBaseSchema.extend({
        kind: z.literal("Props2NumberArrayComputed"),
        unit: props2NumberUnitSchema.nullable(),
        valueNumberArrayComputed: z.array(z.number()).nullable(),
    }),
    props2ComputedConsolidatedBaseSchema.extend({
        kind: z.literal("Props2TextArrayComputed"),
        valueTextArrayComputed: z.array(z.string()).nullable(),
    }),
]);
export const props2NonComputeDefinitionSchema = z.union([
    props2BoolSchema.pick({ key: true, kind: true }),
    props2NumberSchema.pick({
        key: true,
        kind: true,
        allowedValuesNumber: true,
        range: true,
        unit: true,
    }),
    props2TextSchema.pick({ key: true, kind: true, allowedValuesText: true }),
    props2TextArraySchema.pick({
        key: true,
        kind: true,
        allowedValuesText: true,
    }),
    props2NumberArraySchema.pick({
        key: true,
        kind: true,
        allowedValuesNumber: true,
        range: true,
        unit: true,
    }),
]);
//# sourceMappingURL=props2-zod-schema.generated.js.map